// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/search-results/search-results.component.scss
// module id = 489
// module chunks = 0